import { Col, Row } from 'antd';
import { useEffect, useRef } from 'react';

import CloseOutlined from '../../assets/common/CloseOutlined';
import WorkflowSelectDropdown from '../../CommonComponents/specific/WorkflowSelectDropdown/WorkflowSelectDropdown';
import styles from './SelectedOptionContainer.module.scss';

const SelectedOptionContainer = ({
  selectedOption,
  onClose,
  selectedAction,
  setSelectedAction,
  selectedOptionContainerOpen,
  setSelectedOptionContainerOpen,
}) => {
  const isGradient = selectedOption === "MikeLegal's Magic";
  const selectRef = useRef(null);

  useEffect(() => {
    if (selectedOption) {
      selectRef.current?.focus();
    }
  }, [selectedOption]);

  const onSelectChange = (value, option) => {
    setSelectedAction(
      selectedAction?.key === value
        ? {}
        : {
            key: value,
            label: option?.label,
          }
    );
  };

  return (
    <div className='mb-24'>
      <WorkflowSelectDropdown
        ref={selectRef}
        type={selectedOption === "MikeLegal's Magic" ? 'mikeLegalMagic' : 'workflow'}
        open={selectedOptionContainerOpen}
        value={selectedAction?.key}
        onChange={onSelectChange}
        onOpenChange={setSelectedOptionContainerOpen}
      >
        {({ SelectComponent }) => (
          <Row align='middle' wrap={false}>
            <Col flex='none'>
              <SelectPrefix
                isGradient={isGradient}
                onClose={onClose}
                selectedOption={selectedOption}
              />
            </Col>
            <Col flex='auto'>{SelectComponent}</Col>
          </Row>
        )}
      </WorkflowSelectDropdown>
    </div>
  );
};

export default SelectedOptionContainer;

const SelectPrefix = ({ isGradient, onClose, selectedOption }) => {
  return (
    <div
      className={`option-btn ${isGradient ? 'gradient' : ''} ${styles.selectPrefix}`}
      style={isGradient ? {} : { backgroundColor: 'var(--background)' }}
    >
      <span className={`fs-14 ${isGradient ? 'text-gradient' : ''}`}>{selectedOption}</span>
      <button className='flex' onClick={onClose} type='button'>
        <CloseOutlined />
      </button>
    </div>
  );
};
